import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { env } from "@/utils/env";
import ScrollToTop from "@/components/common/ScrollToTop";
import { NeedHelpDropdown } from "@/components/common/NeedHelpDropdown";
import { WhatsappSupportButton } from "./WhatsappSupportButton";
import { PencomBackButton } from "./PencomBackButton";
import { PencomFooter } from "./PencomFooter";

const OnboardingLayoutWithSupport = () => {
  const location = useLocation();

  const getPageTitle = () => {
    switch (location.pathname) {
      case "/onboarding/employer-details":
        return "Employer Details - Onboarding";
      case "/onboarding/employer-representative-details":
        return "Employer Representative - Onboarding";
      default:
        return "Onboarding";
    }
  };

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>{`${getPageTitle()} - ${env.APP_NAME}`}</title>
        <meta name="description" content={`Employee Hub Onboarding`} />
      </Helmet>

      <div className="min-h-screen bg-off-white flex flex-col pb-24">
        <header className="bg-white border-b border-stroke h-20 flex items-center justify-end px-8 lg:px-[100px] sticky top-0 z-50">
          <div className="flex items-center gap-6">
            <NeedHelpDropdown />
            <WhatsappSupportButton />
          </div>
        </header>

        <div className="flex-1 w-full">
          <PencomBackButton title="Back" className="mt-8 ml-25" />
          <Outlet />
        </div>
      </div>
      <PencomFooter floating />
    </>
  );
};

export default OnboardingLayoutWithSupport;
